// ECO合约函数的封装
const contract = {
  // 主合约地址//=>4
  masterAddress: 'TAW69gAS7eogMwZnow7k3Z3hWnz7ugeCHq',//'TDuSakXxiCKZx37wDVimjMVLmV5c41YXZF',//'THhmooKH5PuxBRzsx3Wj6QmELCYhPxhvBY',
  masterAddressHex: '4105D72CEF7E1B00581BF5A2EDCA99696FD5228BE8',//'412B2A2D11F4BE381A07085A208B6E138ECEA24DD0',//'4154D5BC60177F4219D65EA22A158C8BE09AF7927E',

  // 门票合约地址//=>4
  ticketsAddress: 'TZHMaoYHWM1P6KtcsvBBNpGZ9kGDbezwXt',//'TEEXZBqzwsg7PbVfRj6FoaLE9sbahQFw8g',//'TG3tL5JvCDY6C4ZVSFkyHT1et4R5EzVXgy',
  ticketsAddressHex: '41FFB98B47AC2C4DA0FB37A3BE2C1029ACE98E0B95',//'412EC63B0996E13141C0826AAE0ED004644F7B64A5',//'4142B33F6FA61B40AAAE6EA246CBB00FBA47DC8F63',

  // USDT合约地址//=>2
  uAddress: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
  uAddressHex: '41A614F803B6FD780986A42C78EC9C7F77E6DED13C',

  // 默认推荐人; 当不填推荐人的时候使用这个//=>4
  defaultReferrer: 'TVmTxZRXfANnXZEih4XDVpyPt4YZ2q6fsz',//已改
//===================================================================
  // USDT合约abi //=>2 for prod //has trouble which cannot get
  //uAbi: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_upgradedAddress","type":"address"}],"name":"deprecate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"deprecated","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_evilUser","type":"address"}],"name":"addBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"upgradedAddress","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"maximumFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"_totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_maker","type":"address"}],"name":"getBlackListStatus","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_subtractedValue","type":"uint256"}],"name":"decreaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"who","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_value","type":"uint256"}],"name":"calcFee","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"who","type":"address"}],"name":"oldBalanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newBasisPoints","type":"uint256"},{"name":"newMaxFee","type":"uint256"}],"name":"setParams","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"issue","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_addedValue","type":"uint256"}],"name":"increaseApproval","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"amount","type":"uint256"}],"name":"redeem","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"basisPointsRate","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"","type":"address"}],"name":"isBlackListed","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_clearedUser","type":"address"}],"name":"removeBlackList","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"MAX_UINT","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_blackListedUser","type":"address"}],"name":"destroyBlackFunds","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"inputs":[{"name":"_initialSupply","type":"uint256"},{"name":"_name","type":"string"},{"name":"_symbol","type":"string"},{"name":"_decimals","type":"uint8"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_blackListedUser","type":"address"},{"indexed":false,"name":"_balance","type":"uint256"}],"name":"DestroyedBlackFunds","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Issue","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"amount","type":"uint256"}],"name":"Redeem","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"newAddress","type":"address"}],"name":"Deprecate","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_user","type":"address"}],"name":"AddedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_user","type":"address"}],"name":"RemovedBlackList","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"name":"feeBasisPoints","type":"uint256"},{"indexed":false,"name":"maxFee","type":"uint256"}],"name":"Params","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"previousOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}],

  // 主合约abi//=>2
  masterAbi: [ { "inputs": [ { "internalType": "contract IERC20", "name": "_usdt", "type": "address" } ], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" } ], "name": "OwnershipTransferred", "type": "event" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "accounts", "outputs": [ { "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "referrer", "type": "address" }, { "internalType": "bool", "name": "reinvest", "type": "bool" }, { "internalType": "uint8", "name": "nodeLevel", "type": "uint8" }, { "internalType": "uint256", "name": "joinTime", "type": "uint256" }, { "internalType": "uint256", "name": "lastTakeTime", "type": "uint256" }, { "internalType": "uint256", "name": "deposit", "type": "uint256" }, { "internalType": "uint256", "name": "nodeIncome", "type": "uint256" }, { "internalType": "uint256", "name": "dayPoolIncome", "type": "uint256" }, { "internalType": "uint256", "name": "weekPoolIncome", "type": "uint256" }, { "internalType": "uint256", "name": "dynamicIncome", "type": "uint256" }, { "internalType": "uint256", "name": "income", "type": "uint256" }, { "internalType": "uint256", "name": "maxIncome", "type": "uint256" }, { "internalType": "uint256", "name": "reward", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "activateNodeBurn", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "activateNodeBurnAmount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "pure", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_steps", "type": "uint256" } ], "name": "activeInsurance", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "next", "type": "address" } ], "name": "activeSustainable", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "airdropRate", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "burns", "outputs": [ { "internalType": "bool", "name": "active", "type": "bool" }, { "internalType": "uint256", "name": "income", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "addr", "type": "address" } ], "name": "calculateStaticIncome", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "createdAt", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint64", "name": "", "type": "uint64" } ], "name": "dayPool", "outputs": [ { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "date", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "dayPoolId", "outputs": [ { "internalType": "uint64", "name": "", "type": "uint64" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint64", "name": "_id", "type": "uint64" }, { "internalType": "uint8", "name": "_rank", "type": "uint8" } ], "name": "dayPoolRank", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint64", "name": "_id", "type": "uint64" }, { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "dayPoolValue", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "dayWeekData1", "outputs": [ { "internalType": "uint256", "name": "_dayPoolId", "type": "uint256" }, { "internalType": "uint256", "name": "_weekPoolId", "type": "uint256" }, { "internalType": "uint256", "name": "_dayPoolAmount", "type": "uint256" }, { "internalType": "uint256", "name": "_dayPoolDate", "type": "uint256" }, { "internalType": "uint256", "name": "_weekPoolAmount", "type": "uint256" }, { "internalType": "uint256", "name": "_weekPoolDate", "type": "uint256" }, { "internalType": "uint256", "name": "_staticIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_paid", "type": "uint256" }, { "internalType": "bool", "name": "_bo", "type": "bool" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "dayWeekData34", "outputs": [ { "internalType": "uint256", "name": "_directPerf", "type": "uint256" }, { "internalType": "uint256", "name": "_wholeLine", "type": "uint256" }, { "internalType": "address", "name": "_dayChampAddr", "type": "address" }, { "internalType": "uint256", "name": "_dayChampIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_dayChampPerf", "type": "uint256" }, { "internalType": "address", "name": "_daySecondAddr", "type": "address" }, { "internalType": "address", "name": "_dayThirdAddr", "type": "address" }, { "internalType": "address", "name": "_weekChampAddr", "type": "address" }, { "internalType": "uint256", "name": "_weekChampIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_weekChampPerf", "type": "uint256" }, { "internalType": "address", "name": "_weekSecondAddr", "type": "address" }, { "internalType": "uint256", "name": "_weekSecondIncome", "type": "uint256" }, { "internalType": "address", "name": "_maxDepositAddr", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "dayWeekData56", "outputs": [ { "internalType": "uint256", "name": "_createdAt", "type": "uint256" }, { "internalType": "uint256", "name": "_insurance", "type": "uint256" }, { "internalType": "uint256", "name": "_sustainable", "type": "uint256" }, { "internalType": "uint256", "name": "_max", "type": "uint256" }, { "internalType": "uint256", "name": "_min", "type": "uint256" }, { "internalType": "uint256", "name": "_nodeIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_nodeBurnIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_untakeIncome", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "dex", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "founder", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "getBalAndRate", "outputs": [ { "internalType": "uint256", "name": "_yesBal", "type": "uint256" }, { "internalType": "uint256", "name": "_nowBal", "type": "uint256" }, { "internalType": "uint256", "name": "_staticRate", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "id", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "insurance", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "isFloatingStaticRate", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "referrer", "type": "address" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "join", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "joinBurnRate", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "managerAddrs", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "managers", "outputs": [ { "internalType": "bool", "name": "isManager", "type": "bool" }, { "internalType": "uint8", "name": "weightId", "type": "uint8" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "mangersLen", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "maxInvestAmount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "maxInvestAmountPerDay", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "nodeBurnNumber", "outputs": [ { "internalType": "uint32", "name": "", "type": "uint32" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint8", "name": "level", "type": "uint8" } ], "name": "nodeLength", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint8", "name": "", "type": "uint8" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "nodes", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "operation", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "performances", "outputs": [ { "internalType": "uint256", "name": "performance", "type": "uint256" }, { "internalType": "uint256", "name": "wholeLine", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "richmanLength", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_airdropRate", "type": "uint256" } ], "name": "setAirdropRate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint8", "name": "level", "type": "uint8" }, { "internalType": "uint256", "name": "_rate", "type": "uint256" } ], "name": "setDynamicRates", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "setFloatingFlag", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_joinBurnRate", "type": "uint256" } ], "name": "setJoinBurnRate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_manager", "type": "address" } ], "name": "setManagers", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_maxAmount", "type": "uint256" } ], "name": "setMaxInvestAmount", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_amountLimit", "type": "uint256" } ], "name": "setMaxInvestAmountPerDay", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_rate", "type": "uint256" } ], "name": "setStaticRate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "contract ITicketsToken", "name": "_ticket", "type": "address" } ], "name": "setTicket", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "staticRate", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "stats", "outputs": [ { "internalType": "uint256", "name": "income", "type": "uint256" }, { "internalType": "uint256", "name": "investment", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "sustainable", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "take", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "takeDex", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "takeFounder", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "takeOperation", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "takePoolIncome", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "takeReward", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_addr1", "type": "address" }, { "internalType": "address", "name": "_addr2", "type": "address" }, { "internalType": "address", "name": "_addr3", "type": "address" } ], "name": "takeThirdPool", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "teams", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "addr", "type": "address" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "teamsCount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "addr", "type": "address" } ], "name": "teamsLength", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "addr", "type": "address" } ], "name": "teamsStats", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "thirdPool", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalRevenue", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "newOwner", "type": "address" } ], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "triggerOpenPool", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint64", "name": "", "type": "uint64" } ], "name": "weekPool", "outputs": [ { "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "uint256", "name": "date", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "weekPoolId", "outputs": [ { "internalType": "uint64", "name": "", "type": "uint64" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint64", "name": "_id", "type": "uint64" }, { "internalType": "uint8", "name": "_rank", "type": "uint8" } ], "name": "weekPoolRank", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint64", "name": "_id", "type": "uint64" }, { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "weekPoolValue", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_tokenAddress", "type": "address" } ], "name": "withdrawalToken", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "yesFundPoolBal", "outputs": [ { "internalType": "uint256", "name": "value", "type": "uint256" }, { "internalType": "uint256", "name": "updateTime", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "yesterRevenue", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "yesterUpdateTime", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" } ],

  // 门票合约abi //=>for test
  ticketsAbi:[ { "inputs": [ { "internalType": "string", "name": "_name", "type": "string" }, { "internalType": "string", "name": "_symbol", "type": "string" }, { "internalType": "uint8", "name": "_decimals", "type": "uint8" }, { "internalType": "uint256", "name": "_cap", "type": "uint256" }, { "internalType": "contract IERC20", "name": "_usdt", "type": "address" } ], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" } ], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": false, "internalType": "address", "name": "_token", "type": "address" } ], "name": "NewTicketsToken", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" } ], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" } ], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "accounts", "outputs": [ { "internalType": "uint256", "name": "id", "type": "uint256" }, { "internalType": "address", "name": "referrer", "type": "address" }, { "internalType": "uint256", "name": "joinTime", "type": "uint256" }, { "internalType": "uint256", "name": "lastTakeTime", "type": "uint256" }, { "internalType": "uint256", "name": "eidExIncome", "type": "uint256" }, { "internalType": "uint256", "name": "eidMatIncome", "type": "uint256" }, { "internalType": "uint256", "name": "eidNodeMatIncome", "type": "uint256" }, { "internalType": "uint256", "name": "eidNodeExIncome", "type": "uint256" }, { "internalType": "uint256", "name": "lMineIncome", "type": "uint256" }, { "internalType": "uint256", "name": "totalIncome", "type": "uint256" }, { "internalType": "uint256", "name": "lastlockECOTime", "type": "uint256" }, { "internalType": "uint256", "name": "lockPosiECO", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "referrer", "type": "address" } ], "name": "activeEid", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "activeEidAmount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" }, { "internalType": "uint256", "name": "_ticketAmount", "type": "uint256" } ], "name": "airdrop", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" } ], "name": "allowance", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "approve", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "account", "type": "address" } ], "name": "balanceOf", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "burn", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "account", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "burnFrom", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" }, { "internalType": "uint256", "name": "_usdtAmount", "type": "uint256" } ], "name": "burnFromUsdt", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "calcLMineIncome", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "cap", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "createdAt", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [ { "internalType": "uint8", "name": "", "type": "uint8" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" } ], "name": "decreaseAllowance", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "directPushEIDs", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "eidExIncome", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "eidMatIncome", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "eidMatIncomeLock", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "eidNodeIncome", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "eidNodes", "outputs": [ { "internalType": "bool", "name": "active", "type": "bool" }, { "internalType": "uint8", "name": "nodeLevel", "type": "uint8" }, { "internalType": "uint256", "name": "updateAt", "type": "uint256" }, { "internalType": "uint256", "name": "pledgeAmount", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "eids", "outputs": [ { "internalType": "bool", "name": "active", "type": "bool" }, { "internalType": "uint256", "name": "burnNum", "type": "uint256" }, { "internalType": "uint256", "name": "lockUpdateAt", "type": "uint256" }, { "internalType": "uint256", "name": "eidMatIncomeLock", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_toAddr", "type": "address" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "geniusMint", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "getDataSet", "outputs": [ { "internalType": "uint256", "name": "_ecoBalance", "type": "uint256" }, { "internalType": "uint256", "name": "_lockPosiECO", "type": "uint256" }, { "internalType": "uint256", "name": "_lMineIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_withdrawalAmount", "type": "uint256" }, { "internalType": "uint256", "name": "_eidExIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_expectedIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_eidMatIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_eidNodeIncome", "type": "uint256" }, { "internalType": "uint256", "name": "_pledgeEndTime", "type": "uint256" }, { "internalType": "uint256", "name": "_pledgeAmount", "type": "uint256" }, { "internalType": "uint256", "name": "_activeEidAmount", "type": "uint256" }, { "internalType": "uint256", "name": "_directPushEidLen", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint8", "name": "_index", "type": "uint8" } ], "name": "getEIDNodesNum", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "getEIDsNum", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "id", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" } ], "name": "increaseAllowance", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "isOwner", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "lockPendingAmount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "lockTotalAmount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "managerAddrs", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "managers", "outputs": [ { "internalType": "bool", "name": "isManager", "type": "bool" }, { "internalType": "uint8", "name": "weightId", "type": "uint8" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "mangersLen", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "masterAddress", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "maxExEcoOnce", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "maxVendAmountPerDay", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint8", "name": "", "type": "uint8" }, { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "nodeAddrs", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "name": "operation", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [ { "internalType": "address", "name": "", "type": "address" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "pledgeAmount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "pledgeEndTime", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "pledgeNode", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "price", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_floor", "type": "uint256" }, { "internalType": "uint256", "name": "_rate", "type": "uint256" } ], "name": "setActiveEidFloorRates", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_manager", "type": "address" } ], "name": "setManagers", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "setMasterAddress", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_maxExAmount", "type": "uint256" } ], "name": "setMaxExEcoOnce", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_amountLimit", "type": "uint256" } ], "name": "setMaxVendAmountPerDay", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_rate", "type": "uint256" } ], "name": "setMiningRate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_rate", "type": "uint256" } ], "name": "setReleaseRate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "take", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "takeDirectIncome", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "takeEidExIncome", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "takeLMineIncome", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "takeUnlockIncome", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalRevenue", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalVending", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "transfer", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" } ], "name": "transferFrom", "outputs": [ { "internalType": "bool", "name": "", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "newOwner", "type": "address" } ], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_masterAddr", "type": "address" } ], "name": "transferSalesVolume", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [], "name": "unPledgeNode", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "referrer", "type": "address" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "vending", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_account", "type": "address" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" } ], "name": "vendingAndBurn", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "_addr", "type": "address" } ], "name": "withdrawalAmount", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_tokenAddress", "type": "address" } ], "name": "withdrawalToken", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "yesterRevenue", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "yesterUpdateTime", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" } ],

  uAbi: [ { "inputs": [ { "internalType": "uint256", "name": "initialSupply", "type": "uint256" }, { "internalType": "string", "name": "tokenName", "type": "string" }, { "internalType": "string", "name": "tokenSymbol", "type": "string" } ], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" } ], "name": "Burn", "type": "event" }, { "anonymous": false, "inputs": [ { "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" } ], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" } ], "name": "allowance", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_spender", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" } ], "name": "approve", "outputs": [ { "internalType": "bool", "name": "success", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [ { "internalType": "address", "name": "", "type": "address" } ], "name": "balanceOf", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "uint256", "name": "_value", "type": "uint256" } ], "name": "burn", "outputs": [ { "internalType": "bool", "name": "success", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_from", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" } ], "name": "burnFrom", "outputs": [ { "internalType": "bool", "name": "success", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [ { "internalType": "uint8", "name": "", "type": "uint8" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [ { "internalType": "string", "name": "", "type": "string" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [ { "internalType": "uint256", "name": "", "type": "uint256" } ], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_to", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" } ], "name": "transfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [ { "internalType": "address", "name": "_from", "type": "address" }, { "internalType": "address", "name": "_to", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" } ], "name": "transferFrom", "outputs": [ { "internalType": "bool", "name": "success", "type": "bool" } ], "payable": false, "stateMutability": "nonpayable", "type": "function" } ],
  // //for test 2
  //   masterAddress: 'TWJbWb3RcUFy4hHSKRCnce4yTx1NAfMUTk',//'TDPZku8U6Wr8mJf7ZwCdiSt57dgz5JywAR',//'TQujWJPKs8h2EsTeq9H5oD9vcoihyfeZb3',//'TKmmHb3jVykF1XjUSgm8sy1uTUTgqYvW2h',//'TLeem5RYg3THv7enctWzKYdrPkSj2Y3P2C',
  //   masterAddressHex: '41DF0D3567B334462CD8EAE9CFFA64FAD15CC7050B',//'412583AFC2A6478DB88ED4227150D60008CC525550',//'41A3E1AFBEB8AE4FEF65861DEC4364CB99645C6C50',//'417526FB9A3020DF7378B8B4D2AEF62ECE23A30DE1',
  //
  //   //for test 2
  //   ticketsAddress: 'TWtKb6U3WmmCstjSk4br52WA7j6GF2xyyC',//'TResW1newUh7uf5S7MNH7nitkfcFRvFxQk',//'TQrmeAtZAfsoFa6hv8HXC3BFaG5HBY4gJA',
  //   ticketsAddressHex: '41E56E0F5FF71E5B438D09417F33F82DB13E021610',//'41AC0A3F2EAC2464A62E0A3287C380AFB0D2248031',//'418C05946802B8800A27CC05992339BE81E4BB9477',//'41A35238AE8C9E0D122EBFF5D762F2471A7FF3D03F',
  // // //for test
  // // masterAddress: 'TPagRC2sLM1KKFkfDjVQ21bSerRZjjHzri',//'TPPToh6DXVgiMqvirESiWZcpUq72QXekTK',//'TPamN1pjCS8rqSPbFKsrSUtsommbRM1e2d',
  // // masterAddressHex: '41954F1462E48E09EFF32C5038E27DF6000CC7C68A',//'TPPToh6DXVgiMqvirESiWZcpUq72QXekTK',//'419553352CB2713C83BBFE172A51260C68A364F370',
  // //
  // // //for test
  // // ticketsAddress: 'TAMd4S26Nj5NbcFmTU8BD68Z3fiTmL9Rts',//'TQR5rBqgD7PX69yeVSMDBQMbAq9Qqq2gH4',//'TFTArsZNyph7MJPjZQNj3uUCFqJdcTXBHg',
  // // ticketsAddressHex: '41043D3BE0C560C0D0A308B644534C8672A233B863',//'419E769AE0ECAFAF7ED355DFC1CA6E95124F38B571',//'413C227D0EFE1DD9FF4EF2B6AE8D4C5F73FB7CD07C',
  //
  // //for test
  // uAddress: 'TDeL8NDuPMzNrcxZyh99VES8BffPnHq3M5',
  // uAddressHex: '41284E8C602A048D56F9E7AF3071EFAC2C4500D1AD',
  //
  // defaultReferrer: 'TTNuYa9uPVNLJSBKXsj8Z12B3gU9CU6kqb',
//===================================================================
	// 默认0地址, 替代4100..地址
	defaultAddress0: '0000000000000000000000000000000000',
	defaultAddress41: '410000000000000000000000000000000000000000',
	// 默认授权给合约地址的额度
	usdtAppoveQuota: '999999999000000',//USDT decimals = 1000000,
	ticketAppoveQuota:'35000000000000000000000000',//ECO decimals =1000000000000000000,


	/* ---------------我的自定义----------------- */
	gTronWeb: '',
	gMasterContract: '',
	gTicketsContract: '',
	gUSDTContract: '',
	// 余额少于300提示可能会交易失败
	gTronTips: '300',//=>2

	isTronLink() {
		// 发现有安装钱包 && 钱包是解锁状态; (等1秒,可能会有延迟导致没有获取到tronWeb对象)
		let promise = new Promise(function(resolve, reject) {
			setTimeout(() => {
				if (window.tronWeb) {
					// 如果没有发默认地址会返回false, 可能是钱包被锁定, 也可能是钱包里面没有地址;
					if (window.tronWeb.defaultAddress.base58) {
						resolve({
							status: true,
							data: "正常"
						});
					} else {
						resolve({
							status: false,
							data: "钱包被锁定或钱包里没有地址"
						});
					}
				} else {
					resolve({
						status: false,
						data: "没有发现波场钱包"
					});
				}
			}, 1000);
		});
		// 处理异步返回结果
		return promise;
	},

	// 创建对象
	async createdObject() {
		this.gTronWeb = window.tronWeb;
		// 创建usdt合约,门票合约,主合约对象
		let masterAddr = this.masterAddress;
		let masterAbi = this.masterAbi;
		let uAddr = this.uAddress;
		let uAbi = this.uAbi;
		let ticketsAddr = this.ticketsAddress;
		let ticketsAbi = this.ticketsAbi;
		this.gMasterContract = await this.gTronWeb.contract(masterAbi, masterAddr);
		this.gTicketsContract = await this.gTronWeb.contract(ticketsAbi, ticketsAddr);
		this.gUSDTContract = await this.gTronWeb.contract(uAbi, uAddr);
	},

	// 获取钱包的默认地址
	async defaultAddress() {
		let res = await this.gTronWeb.defaultAddress;
		return res;
	},

	// 获取地址波长币余额
	async getTRXBalance(address) {
		let res = await this.gTronWeb.trx.getBalance(address);
		return res;
	},

	// trx默认地址转换16进制
	async addressToHex(address) {
		let res = await this.gTronWeb.address.toHex(address);
		return res;
	},
	// 16进制地址转换成trx默认地址
	async addressFromHex(address) {
		let res = await this.gTronWeb.address.fromHex(address);
		return res;
	},
	// 查询当前地址授权给主合约的usdt额度
	async allowanceUsdtMast() {
		let addr = await this.gTronWeb.defaultAddress.base58;
		let money = await this.gUSDTContract.allowance(addr, this.masterAddress).call();
		return money;
	},
	// 查询当前地址授权给主合约的eco额度
	async allowanceEcoMast() {
		let addr = await this.gTronWeb.defaultAddress.base58;
		let money = await this.gTicketsContract.allowance(addr, this.masterAddress).call();
		return money;
	},

	// 查询ECO销售量到达多少
	async totalVending() {
		let res = await this.gTicketsContract.totalVending().call();
		return res;
	},

	// // 获取静态收益
	// async calculateStaticIncome(address) {
	// 	let res = await this.gMasterContract.calculateStaticIncome(address).call();
	// 	return res;
	// },

	// 获取地址USDT余额
	async getUsdtBalance(address) {
		let res = await this.gUSDTContract.balanceOf(address).call();
		return res;
	},

	// 关闭浮动利率, 需要很多手续费
	async setFloatingFlag() {
		let result = await this.gMasterContract.setFloatingFlag().send({
			feeLimit:1000000000,
			callValue: 0,
			// true就是20块确认才会给返回值, false就是1个确认就给返回值;
			shouldPollResponse: false
		});
		return result;
	},
  //设置主合约每日最大入场资金 setMaxVendAmountPerDay
  async setMaxInvestAmountPerDay(maxAmount) {
    let result = await this.gMasterContract.setMaxInvestAmountPerDay(maxAmount).send({
      feeLimit:1000000000,
      callValue: 0,
      shouldPollResponse: false
    });
    return result;
  },

  //maxInvestAmountPerDay 日最大投资限制
  async getMaxInvestAmountPerDay() {
    return await this.gMasterContract.maxInvestAmountPerDay().call();
  },
  //当前总收益
  async getTotalRevenue() {
    return await this.gMasterContract.totalRevenue().call();
  },
  //昨日总收益
  async getYesterRevenue() {
    return await this.gMasterContract.yesterRevenue().call();
  },
  //昨日总投资更新时间 yesterUpdateTime
  async getYesterUpdateTime() {
    return await this.gMasterContract.yesterUpdateTime().call();
  },

  //获取浮动利率isFloatingStaticRate
  async isFloatingStaticRate() {
    return await this.gMasterContract.isFloatingStaticRate().call();
  },

	// 获取门票合约的流通量
	async totalVendingTickets() {
		return await this.gTicketsContract.totalVending().call();
	},
  // 获取门票合约单次共振最大额度
  async maxExEcoOnce() {
    return await this.gTicketsContract.maxExEcoOnce().call();
  },
  // 获取门票合约当前管理者数量
  async ticketMangersLen() {
    return await this.gTicketsContract.mangersLen().call();
  },

  // 获取门票合约当前E级数量
  async getEIDNodesNum(index) {
    return await this.gTicketsContract.getEIDNodesNum(index).call();
  },
  //eidAddrs
  async getEIDsNum() {
    return await this.gTicketsContract.getEIDsNum().call();
  },
  //maxVendAmountPerDay
  async getMaxVendAmountPerDay() {
    return await this.gTicketsContract.maxVendAmountPerDay().call();
  },
  // 设置门票合约单次共振最大额度
  async setMaxExEcoOnce(maxAmount) {
    let result = await this.gTicketsContract.setMaxExEcoOnce(maxAmount).send({
      feeLimit:1000000000,
      callValue: 0,
      shouldPollResponse: false
    });
    return result;
  },
  //设置门票合约每日最大入场资金 setMaxVendAmountPerDay
  async setMaxVendAmountPerDay(maxAmount) {
    let result = await this.gTicketsContract.setMaxVendAmountPerDay(maxAmount).send({
      feeLimit:1000000000,
      callValue: 0,
      shouldPollResponse: false
    });
    return result;
  },
	// 获取主合约投资的最大限制
	async maxInvestAmount() {
	 return await this.gMasterContract.maxInvestAmount().call();
	},

  // 获取当前主合约管理者数量
  async masterMangersLen() {
    return await this.gMasterContract.mangersLen().call();
  },

	// 设置主合约投资的最大限制
	async setMaxInvestAmount(maxAmount) {
		let result = await this.gMasterContract.setMaxInvestAmount(maxAmount).send({
			feeLimit:1000000000,
			callValue: 0,
			shouldPollResponse: false
		});
		return result;
	},
  // 设置主合约投资的燃烧比例
  async setJoinBurnRate(joinBurnRate) {
    let result = await this.gMasterContract.setJoinBurnRate(joinBurnRate).send({
      feeLimit:1000000000,
      callValue: 0,
      shouldPollResponse: false
    });
    return result;
  },
  // 获取主合约投资的燃烧比例
  async getJoinBurnRate() {
    let result = await this.gMasterContract.joinBurnRate().call();
    return result;
  },
  // 设置主合约投资的空投比例
  async setAirdropRate(airdropRate) {
    let result = await this.gMasterContract.setAirdropRate(airdropRate).send({
      feeLimit:1000000000,
      callValue: 0,
      shouldPollResponse: false
    });
    return result;
  },
  //获取主合约空投比例
  async getAirdropRate() {
    let result = await this.gMasterContract.airdropRate().call();
    return result;
  },

	// 获取主合约owner地址
	async getMasterTotalRevenue() {
		let res = await this.gMasterContract.totalRevenue().call();
		return res;
	},
  // 获取主合约总投资地址数
  async getMasterAccountId() {
    let res = await this.gMasterContract.id().call();
    return res;
  },
  // 获取主合约总投资额
  async getMasterOwner() {
    let res = await this.gMasterContract.owner().call();
    return res;
  },
  // 获取各级节点的数量
  async getMasterNodeLength(level) {
    let res = await this.gMasterContract.nodeLength(level).call();
    return res;
  },

  //获取投资超过5000U的人数
  async getRichmanLength() {
    let res = await this.gMasterContract.richmanLength().call();
    return res;
  },

	// 获取门票合约owner地址
	async getTicketsOwner() {
		let res = await this.gTicketsContract.owner().call();
		return res;
	},

	// 判断是不是主合约管理员
	async masterManager(address) {
	 return await this.gMasterContract.managers(address).call();
	},

	// 判断是不是门票合约管理员
	async ticketsManager(address) {
	 return await this.gTicketsContract.managers(address).call();
	},

	// 设置主合约的管理者地址
	async setMasterManagers(address1) {
		let result = await this.gMasterContract.setManagers(address1).send({
			feeLimit:1000000000,
			callValue: 0,
			shouldPollResponse: false
		});
		return result;
	},

	// 设置门票合约的三个管理者地址
	async setTicketsManagers(address1) {
		let result = await this.gTicketsContract.setManagers(address1).send({
			feeLimit:1000000000,
			callValue: 0,
			shouldPollResponse: false
		});
		return result;
	},

	/* 全部查询 */
	// 门票合约
	async getDataSet(address) {
	  return await this.gTicketsContract.getDataSet(address).call();
	 },

	 // 主合约 - 日周奖池+input 那一块
	 async dayWeekData1(address) {
	  return await this.gMasterContract.dayWeekData1(address).call();
	 },

	 // 主合约 - 我的邀请链接+今日冠军推广业绩 那两块
	 async dayWeekData34(address) {
	  return await this.gMasterContract.dayWeekData34(address).call();
	 },

	 // 主合约 - 保险池+全球节点 那两块
	 async dayWeekData56(address) {
	  return await this.gMasterContract.dayWeekData56(address).call();
	 },
	/* ---------------我的自定义 end----------------- */

	// 获取当前地址授权给合约地址的额度
	async allowance() {
		let addr = await this.gTronWeb.defaultAddress.base58;
		let money = await this.gUSDTContract.allowance(addr, this.ticketsAddress).call();
		return money;
	},

	// 授权usdt给门票合约地址 ====>对应Ecoswap网页 "批准",(批准按钮包含两笔交易，1是授权USDT給门票合约，2是调用门票合约的vending接口购买ticketsToken)
	async approveTickets() {
		console.log('开始授权USDT给门票合约');
		// 进行授权
		let addr = this.ticketsAddress;
		let value = this.usdtAppoveQuota;
		let result = await this.gUSDTContract.approve(addr, value).send({
			feeLimit:1000000000,
			callValue: 0,
			// true就是20块确认才会给返回值, false就是1个确认就给返回值;
			shouldPollResponse: false
		});
		console.log('授权的返回值', result);
		return result;
	},

	//门票合约接口
	// 投资USDT购买门票接口  ====>对应Ecoswap网页 "批准",批准按钮包含两笔交易，1是授权USDT給门票合约，2是调用门票合约的vending接口购买ticketsToken
	async vending(referrer, value) {
		try {
			let result = await this.gTicketsContract.vending(referrer, value).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('购买的返回值', result);
			return result;
		} catch (e) {
			console.log("vending error:",e);
		}
	},

	// 查询是否已经激活过EIC, 消耗1000ECO的
	async isActiveEid(address) {
		return await this.gTicketsContract.eids(address).call();
	},

	// 激活ESD身份,会消耗1000ECO，可根据ECO余额变化判断，激活是否成功
	async activeEid(address) {// ====>对应Ecoswap网页 "ESD 激活"
		try {
			let result = await this.gTicketsContract.activeEid(address).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('激活ESD身份的返回值',result);

			return result;
		} catch(error){
			console.log("activeEid error:",error);
		}

	},

	// 激活ESD节点身份,会质押至少3000ECO到门票合约，可根据ECO余额变化判断，激活是否成功
	async pledgeNode(amount) {//输入带精度的数值// ====>对应Ecoswap网页 "E级节点 质押"
		try {
			let result = await this.gTicketsContract.pledgeNode(amount).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('激活ESD节点的返回值',result);

			return result;
		} catch(error){
			console.log("pledgeNode error:",error);
		}

	},

	// 注销ESD节点身份,并拿回质押的ECO，可根据ECO余额变化判断注销是否成功
	async unPledgeNode() {// ====>对应Ecoswap网页 "已质押 撤资"
		try {
			let result = await this.gTicketsContract.unPledgeNode().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('注销ESD节点的返回值',result);

			return result;
		} catch(error){
			console.log("unPledgeNode error:",error);
		}

	},
	// 取现已获得直接收益，可根据ECO余额变化判断取现是否成功
	async takeDirectIncome() {
		try {
			let result = await this.gTicketsContract.takeDirectIncome().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现已获得直接收益的返回值',result);

			return result;
		} catch(error){
			console.log("takeDirectIncome error:",error);
		}

	},

	// 取现ESD共振兑换收益，可根据ECO余额变化判断取现是否成功
	async takeEidExIncome() {// ====>对应Ecoswap网页 "ESD共振收益 提现"
		try {
			let result = await this.gTicketsContract.takeEidExIncome().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现ESD共振兑换收益的返回值',result);

			return result;
		} catch(error){
			console.log("takeEidExIncome error:",error);
		}

	},
	// 取现解锁的收益，包括流动性挖矿和ESD矩阵释放收益，可根据ECO余额变化判断取现是否成功
	async takeUnlockIncome() {// ====>对应Ecoswap网页 "可提现数量 提取"
		try {
			let result = await this.gTicketsContract.takeUnlockIncome().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现解锁的收益的返回值',result);

			return result;
		} catch(error){
			console.log("takeUnlockIncome error:",error);
		}

	},

	// 取现流动性挖矿收益，可根据ECO余额变化判断取现是否成功
	async takeLMineIncome() {
		try {
			let result = await this.gTicketsContract.takeLMineIncome().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现流动性挖矿收益的返回值',result);

			return result;
		} catch(error){
			console.log("takeLMineIncome error:",error);
		}
	},

	// 取现所有收益，可根据ECO余额变化判断取现是否成功
	async take() {// ====>对应Ecoswap网页 "提现-最大按钮"
		try {
			let result = await this.gTicketsContract.take().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现所有收益的返回值',result);

			return result;
		} catch(error){
			console.log("take error:",error);
		}
	},
	//======================门票合约 管理员操作接口 start=====================
	// 取现技术团队基金，可根据USDT余额变化判断取现是否成功 (USDT奖励20%)
	async takeFounder() {//只能管理员操作
		try {
			let result = await this.gTicketsContract.takeFounder().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现技术团队基金的返回值',result);

			return result;
		} catch(error){
			console.log("takeFounder error:",error);
		}
	},

	// 转移门票合约80%的USDT销售量(USDT余额)到其他地址，可根据门票合约的USDT余额变化判断转移是否成功
	async transferSalesVolume(_masterAddr) {//只能管理员操作
		try {
			let result = await this.gTicketsContract.transferSalesVolume(_masterAddr).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现技术团队基金的返回值',result);

			return result;
		} catch(error){
			console.log("transferSalesVolume error:",error);
		}
	},

	// 管理员增发门票token，可根据门票token的总量变化判断增发是否成功
	async geniusMint(_address,_amount) {//只能管理员操作
		try {
			let result = await this.gTicketsContract.geniusMint(_address,_amount).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现技术团队基金的返回值',result);

			return result;
		} catch(error){
			console.log("geniusMint error:",error);
		}
	},

	// 设置流动性挖矿释放率(解锁率)
	async setMiningRate(_rate) {//只能管理员操作
		try {
			let result = await this.gTicketsContract.setMiningRate(_rate).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('设置流动性挖矿日释放率的返回值',result);

			return result;
		} catch(error){
			console.log("setMiningRate error:",error);
		}
	},

	// 设置ESD矩阵释放率
	async setReleaseRate(_rate) {//只能管理员操作
		try {
			let result = await this.gTicketsContract.setReleaseRate(_rate).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('设置ESD矩阵日释放率的返回值',result);

			return result;
		} catch(error){
			console.log("setReleaseRate error:",error);
		}
	},

	// 设置ESD矩阵收益某层的日释放率 (ESD激活层数收益率)
	async setActiveEidFloorRates(_floor,_rate) {//只能管理员操作
		try {
			let result = await this.gTicketsContract.setActiveEidFloorRates(_floor,_rate).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('设置ESD矩阵收益某层的日释放率的返回值',result);

			return result;
		} catch(error){
			console.log("setActiveEidFloorRate error:",error);
		}
	},

	// 更改主合约管理员
	async changeOwnerMaster(address) {
		try {
			let result = await this.gMasterContract.transferOwnership(address).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('更改主合约管理员',result);

			return result;
		} catch(error){
			console.log("更改主合约管理员 error:",error);
		}

	},

	// 更改门票合约管理员
	async changeOwnerTickets(address) {
		try {
			let result = await this.gTicketsContract.transferOwnership(address).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('更改门票合约管理员',result);

			return result;
		} catch(error){
			console.log("更改门票合约管理员 error:",error);
		}

	},

	//======================管理员操作接口 end=====================

	//===========门票合约查询接口==================================
	// 折线图下面的第一块
	// 获取ECO余额, 持有量
	async getEcoBalance(address) {
		return await this.gTicketsContract.balanceOf(address).call();
	},

	//获取用户流动性挖矿收益  ====>对应Ecoswap网页 "ECO流動性挖礦收益"
	async calcLMineIncome(address) {
		return await this.gTicketsContract.calcLMineIncome(address).call();
	},

	//获取用户可取现数额  ====>对应Ecoswap网页 "可提取数量"
	async withdrawalAmount(address) {
		return await this.gTicketsContract.withdrawalAmount(address).call();
	},

	//获取用户ESD共振(兑换)收益  ====>对应Ecoswap网页 "ESD共振收益"
	async eidExIncome(address) {
		return await this.gTicketsContract.eidExIncome(address).call();
	},

	//获取用户的已释放的期望收益  ====>对应Ecoswap网页 "预计可提取收益"
	async expectedIncome(address) {
		return await this.gTicketsContract.eidMatIncomeLock(address).call();
	},
	//获取用户ESD矩阵收益  ====>对应Ecoswap网页 "ESD矩阵收益"
	async eidMatIncome(address) {
		return await this.gTicketsContract.eidMatIncome(address).call();
	},

	//获取用户的ESD节点收益  ====>对应Ecoswap网页 "ESD节点分红收益"
	async eidNodeIncome(address) {
		return await this.gTicketsContract.eidNodeIncome(address).call();
	},

	// E级节点, 0=没有, 1=E1, 2=E2...
	async eidNodes(address) {
		return await this.gTicketsContract.eidNodes(address).call()
	},
	//获取激活ESD的人数  ====>对应Ecoswap网页 "总计激活人数"
	async activeEidAmount() {
		return await this.gTicketsContract.activeEidAmount().call();
	},
	//获取ESD节点质押结束时间，需手动取回质押额度ECO  ====>对应Ecoswap网页 "可撤资倒计时"
	async pledgeEndTime(address) {
		return await this.gTicketsContract.pledgeEndTime(address).call();
	},
	//获取ESD节点的质押数额  ====>对应Ecoswap网页 "已质押"
	async pledgeAmount(address) {
		return await this.gTicketsContract.pledgeAmount(address).call();
	},


	/*****************************************************************/
	// ===============主合约页面接口 start================================
	// 授权usdt给主合约地址
	async approveMaster() {
		console.log('开始授权USDT给主合约');
		// 进行授权
		let addr = this.masterAddress;
		let value = this.usdtAppoveQuota;
		let result = await this.gUSDTContract.approve(addr, value).send({
			feeLimit:1000000000,
			callValue: 0,
			// true就是20块确认才会给返回值, false就是1个确认就给返回值;
			shouldPollResponse: false
		});
		console.log('授权的返回值', result);
		return result;
	},
	// 授权ticketToken给主合约地址
	async approveTickToMaster() {
		console.log('开始授权ticketToken给主合约');
		// 进行授权
		let addr = this.masterAddress;
		let value = this.ticketAppoveQuota;
		let result = await this.gTicketsContract.approve(addr, value).send({
			feeLimit:1000000000,
			callValue: 0,
			// true就是20块确认才会给返回值, false就是1个确认就给返回值;
			shouldPollResponse: false
		});
		console.log('授权的返回值', result);
		return result;
	},

	// 投资USDT参与master game  ====>对应主页 "批准",批准按钮包含两笔交易，1是授权USDT給主合约，2是调用主合约的join接口参与
	async join(referrer, uAmount) {
		try {
			let result = await this.gMasterContract.join(referrer, uAmount).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('投资的返回值', result);
			return result;
		} catch (e) {
			console.log("join error:",e);
		}
	},


	// 触发奖池开奖，可根据dayPoolId和weekPoolId是否+1，判断触发是否成功
	async triggerOpenPool() {
		try {
			let result = await this.gMasterContract.triggerOpenPool().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('触发奖池开奖返回值',result);

			return result;
		} catch(error){
			console.log("triggerOpenPool error:",error);
		}
	},
	//======================主合约 管理员操作接口 start=====================
	// 激活保险池，可根据状态insurance是否置0，判断激活是否成功
	async activeInsurance(steps) {
		try {
			let result = await this.gMasterContract.activeInsurance(steps).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('激活保险池返回值',result);

			return result;
		} catch(error){
			console.log("activeInsurance error:",error);
		}
	},
	// 激活永续池，判断_nextAddr的USDT余额是否变化
	async activeSustainable(_nextAddr) {
		try {
			let result = await this.gMasterContract.activeSustainable(_nextAddr).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('激活永续池返回值',result);

			return result;
		} catch(error){
			console.log("activeSustainable error:",error);
		}
	},

	// 设置静态日收益率
	async setStaticRate(_rate) {//只能管理员操作
		try {
			let result = await this.gMasterContract.setStaticRate(_rate).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('设置静态日利率的返回值',result);

			return result;
		} catch(error){
			console.log("setStaticRate error:",error);
		}
	},
	// 设置动态加速层数收益率
	async setDynamicRates(_level,_rate) {//只能管理员操作
		try {
			let result = await this.gMasterContract.setDynamicRates(_level,_rate).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('设置动态加速层数收益率的返回值',result);

			return result;
		} catch(error){
			console.log("setDynamicRates error:",error);
		}
	},
	// 设置门票合约地址
	async setTicket(_ticketAddr) {//只能管理员操作
		try {
			let result = await this.gMasterContract.setTicket(_ticketAddr).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('设置门票合约地址的返回值',result);

			return result;
		} catch(error){
			console.log("setTicket error:",error);
		}
	},

	// 取现技术团队基金，可根据owner的USDT余额变化判断取现是否成功 (团队技术奖励)
	async takeFounder_master(_addr) {//只能管理员操作
		try {
			let result = await this.gMasterContract.takeFounder(_addr).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现技术团队基金的返回值',result);

			return result;
		} catch(error){
			console.log("takeFounder error:",error);
		}
	},

	// 取现运营团队基金，可根据owner的USDT余额变化判断取现是否成功 (拓展运营费用)
	async takeOperation(_addr) {//只能管理员操作
		try {
			let result = await this.gMasterContract.takeOperation(_addr).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现运营团队基金的返回值',result);

			return result;
		} catch(error){
			console.log("takeOperation error:",error);
		}
	},

	// 领取做市资金
	async takeDex(_addr) {//只能管理员操作
		try {
			let result = await this.gMasterContract.takeDex(_addr).send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现运营团队基金的返回值',result);

			return result;
		} catch(error){
			console.log("takeOperation error:",error);
		}
	},

  // 设置主合约的管理者地址
  async takeThirdPool_master(address1,address2,address3) {
    let result = await this.gMasterContract.takeThirdPool(address1,address2,address3).send({
      feeLimit:1000000000,
      callValue: 0,
      shouldPollResponse: false
    });
    return result;
  },
  //thirdPool
  async getThirdPool() {
    return await this.gMasterContract.thirdPool().call();
  },
	//======================管理员操作接口 end=====================

	//============第一部分(日/周奖池/输入框/批准按钮)：主页从上到下总共六部分=====================
	//获取日奖池ID  ====>主网页 "日奖池()里的数值"
	async dayPoolId() {
		return await this.gMasterContract.dayPoolId().call();
	},
	//获取对应ID的日奖池数据  ====>对应主网页 "日奖池数额+时间"，加一天时间开始倒计时
	async dayPool(_id) {
		let res = await this.gMasterContract.dayPool(_id).call();
		let date = res.date._hex;
		let amount = res.amount._hex;

		return res;

	},
	//获取周奖池ID  ====>主网页 "周奖池()里的数值"
	async weekPoolId() {
		return await this.gMasterContract.weekPoolId().call();
	},
	//获取对应ID的日奖池数据  ====>对应主网页 "周奖池数额+时间"，加7天时间开始倒计时
	async weekPool(_id) {
		let res = await this.gMasterContract.weekPool(_id).call();
		let date = res.date._hex;
		let amount = res.amount._hex;
		return res;
	},
	//获取当前ECO token价格 ECO/U  ====>对应主网页 "共振比例" 用300 * price = 对应ECO数量
	async price() {
		return await this.gTicketsContract.price().call();
	},

	//============第二部分：主页从上到下总共六部分=====================

	// ====>对应主网页 "倒计时"：不确定是不是定时触发triggerOpenPool()接口的倒计时
	//获取用户已提现收益
	async takedIncome(_addr) {     		   //====>对应主网页 "已提现收益"
		let res = await this.gMasterContract.stats(_addr).call();
		return res.income._hex;
	},
	async formatSeconds(value) {
		var secondTime = parseInt(value);// 秒
		var minuteTime = 0;// 分
		var hourTime = 0;// 小时
		if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
			//获取分钟，除以60取整数，得到整数分钟
			minuteTime = parseInt(secondTime / 60);
			//获取秒数，秒数取佘，得到整数秒数
			secondTime = parseInt(secondTime % 60);
			//如果分钟大于60，将分钟转换成小时
			if(minuteTime > 60) {
				//获取小时，获取分钟除以60，得到整数小时
				hourTime = parseInt(minuteTime / 60);
				//获取小时后取佘的分，获取分钟除以60取佘的分
				minuteTime = parseInt(minuteTime % 60);
			}
		}
		var result = "" + parseInt(secondTime) + ":";

		if(minuteTime > 0) {
			result = "" + parseInt(minuteTime) + ":" + result;
		}
		if(hourTime > 0) {
			result = "" + parseInt(hourTime) + ":" + result;
		}
		return result;
	},
	//获取用户数据
	async userData(_addr) {
		let res = await this.gMasterContract.accounts(_addr).call();
		let nodeLevel = res.nodeLevel._hex;////====>对应主网页 "V1/V2/V3/V4",1=>V1,2=>V2,3=>V3,4=>V4
		let joinTime = res.joinTime._hex;
		let nowTimeSec=Date.parse(new Date());
		let sec100Days = 86400*100;
		let countdown100DaySec = (parseInt(joinTime)+sec100Days)-nowTimeSec;
		let cd100DayString = await this.formatSeconds(countdown100DaySec);//====>对应主网页本部分 第一行的"倒计时"
		let dayPoolIncome = res.dayPoolIncome._hex;//====>对应主网页 "日奖池收益"
		let weekPoolIncome = res.weekPoolIncome._hex;//====>对应主网页 "周奖池收益"
		let dynamicIncome = res.dynamicIncome._hex;//====>对应主网页 "动态收益"
		let reward = res.reward._hex;//====>对应主网页 "分红收益"
		let oneDaySec = 86400;
		let countdownTime  = oneDaySec - (nowTimeSec-joinTime)%oneDaySec;
		let cdTimeString = await this.formatSeconds(countdownTime);//====>对应主网页 "下次分红倒计时时分秒"
		let deposit = res.deposit._hex;//====>对应主网页 "存入资金"
		let maxIncome = res.maxIncome._hex;
		let AcceleratedExit = parseInt(maxIncome)/parseInt(deposit);//====>对应主网页 "加速出局差"
		let untakeIncome = res.income._hex;//====>对应主网页 "未提现收益"
		return res;
	},
	// struct Account {
	// 	uint256 id;
	// 	address referrer; // Direct push
	// 	bool reinvest; // Whether to reinvest
	// 	uint8 nodeLevel; // Node level
	// 	uint256 joinTime; // Join time: This value needs to be updated when joining again
	// 	uint256 lastTakeTime; // Last time the static income was received
	// 	uint256 deposit; // Deposited quantity: 0 means "out"
	// 	uint256 nodeIncome; // Node revenue balance
	// 	uint256 dayPoolIncome; // Daily bonus pool income balance
	// 	uint256 weekPoolIncome; // Weekly bonus pool income balance
	// 	uint256 dynamicIncome; // Dynamic income balance
	// 	uint256 income; // Total revenue
	// 	uint256 maxIncome; // Exit condition
	// 	uint256 reward; // Additional other rewards
	// }

	// 取现奖金池收益，可根据USDT余额变化判断取现是否成功
	async takePoolIncome() {//====>对应主网页 "日奖池收益"/"周奖池收益"边的"提现"按钮
		try {
			let result = await this.gMasterContract.takePoolIncome().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现奖金池收益的返回值',result);

			return result;
		} catch(error){
			console.log("takePoolIncome error:",error);
		}
	},


	// 取现所有收益，可根据USDT余额变化判断取现是否成功
	async take_master() {//====>对应本部分底部的 提现"按钮
		try {
			let result = await this.gMasterContract.take().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现的返回值', result);
			return result;
		} catch (e) {
			console.log("take0 error:",e);
		}
	},

	// 取现保险池奖励，可根据USDT余额变化判断取现是否成功
	async takeReward() {
		try {
			let result = await this.gMasterContract.takeReward().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('取现保险池奖励的返回值',result);

			return result;
		} catch(error){
			console.log("takeReward error:",error);
		}
	},


	//============第三部分：主页从上到下总共六部分=====================
	//获取当前总业绩  ====>对应主网页 "本轮邀请业绩"
	// ====>对应主网页 "今日邀请金额" 今日业绩=当前总业绩-昨日总业绩，用一个状态记录昨日总业绩，每天更新一次昨日总业绩
	async performances(_addr) {
		let res = await this.gMasterContract.performances(_addr).call();
		return res;
	},
	//获取我的邀请人 ====>对应主网页 "我的邀请人地址"
	async userReferrer(_addr) {
		let res = await this.gMasterContract.accounts(_addr).call();
		return res;
	},
	// 门票合约的; 和上面一样  ====> 对应eco门票合约的 "我的邀请人地址"
	async userReferrerTickets(_addr) {
		let res = await this.gTicketsContract.accounts(_addr).call();
		return res;
	},

	//============第四部分(日/周奖池,冠亚军)：主页从上到下总共六部分=======================
	//获取日冠军地址，输入主页第一部分的dayPoolId和排名号_rank，冠军:_rank==0,
	// 再调用第三部分的 performances(_addr)获取对应地址业绩 //====>对应网页 "今日冠军业绩"
	// 				====>对应网页 "今日中奖地址"，冠军，亚军，季军，输入参数_rank == 0,1,2
	async dayPoolRank(_id,_rank) {
		let addr = await this.gMasterContract.dayPoolRank(_id,_rank).call();
		return addr;
	},
	//获取今日冠军收益，输入当前dayPoolId，和日冠军地址
	async dayPoolValue(_id,_addr) {//====>对应网页 "今日冠军收益"
		let valueIncome = await this.gMasterContract.dayPoolValue(_id,_addr).call();
		return valueIncome._hex;
	},

	//获取周冠军地址，输入主页第一部分的weekPoolId和排名号_rank，冠军:_rank==0,亚军:_rank==1
	// 再调用第三部分的 performances(_addr)获取对应地址业绩 //====>对应主网页 "上轮周冠军邀请业绩"
	// 				====>对应主网页 "上轮周奖池中奖地址"，冠军，亚军，季军，输入参数_rank == 0,1,2
	async weekPoolRank(_id,_rank) {
		let addr =  await this.gMasterContract.weekPoolRank(_id,_rank).call();
		return addr;
	},
	//获取上轮周冠军/亚军收益，输入当前dayPoolId，和周冠军/亚军地址
	async weekPoolValue(_id,_addr) {//====>对应网页 "上轮周冠军/亚军中奖收益"
		let valueIncome = await this.gMasterContract.weekPoolValue(_id,_addr).call();
		return valueIncome._hex;
	},
	//====>对应网页"本轮最大推荐资金" 数据是写死的"150"，左边地址：不知，要不把季军的地址填上去

	//============第五部分(保险池/永续池)：主页从上到下总共六部分=======================
	//获取合约创建时间  ====>对应网页 保险池/永续池的"计时数据"，即 now - createdAt
	async createdAt() {
		return await this.gMasterContract.createdAt().call();
	},
	//获取合约保险池数额  ====>对应网页 index号保险池的"资金数据"
	async insurance(index) {
		return await this.gMasterContract.insurance(index).call();
	},
	//获取合约永续池数额  ====>对应网页 永续池的"资金数据"
	async sustainable() {
		return await this.gMasterContract.sustainable().call();
	},

	//============第六部分(节点/团队)：主页从上到下总共六部分=======================
	//调用第三部分的 performances(_addr)获取钱包地址业绩 //====>对应主网页 "直推业绩"
	async wholePerformances(_addr) {     		   //====>对应主网页 "合计业绩"
		let res = await this.gMasterContract.performances(_addr).call();
		return res;
	},

	async teamsStats(_addr) {     		   //====>对应主网页 "Small" ,"Max"
		let res = await this.gMasterContract.teamsStats(_addr).call();
		return res;
	},

	async nodeIncome(_addr) {     		   //====>对应主网页 "全球节点收益"
		let res = await this.gMasterContract.accounts(_addr).call();
		return res.nodeIncome._hex;
	},

	async nodeBurnIncome(_addr) {     		   //====>对应主网页 "节点焚烧收益"
		let res = await this.gMasterContract.burns(_addr).call();
		return res.income._hex;
	},
	async nodeBurnIncome2(_addr) {     		   //====>对应主网页 "节点焚烧收益"
		let res = await this.gMasterContract.burns(_addr).call();
		return res.active;
	},

	// 激活节点焚烧，可根据ECO余额变化判断取现是否成功
	async activateNodeBurn() {			//====>对应主网页 "节点焚烧"按钮
		try {
			let result = await this.gMasterContract.activateNodeBurn().send({
				feeLimit:1000000000,
				callValue: 0,
				// true就是20块确认才会给返回值, false就是1个确认就给返回值;
				shouldPollResponse: false
			});
			console.log('激活节点焚烧返回值',result);

			return result;
		} catch(error){
			console.log("activateNodeBurn error:",error);
		}
	},


	//获取团队里满足条件的人数  ====>对应网页 ""
	async teamsCount(_addr,_amount) {
		return await this.gMasterContract.teamsCount(_addr,_amount).call();
	},

	//获取  ====>对应网页 ""
	async richmanLength() {
		return await this.gMasterContract.richmanLength().call();
	},



	//获取用户静态收益  ====>对应网页 ""
	async calculateStaticIncome(_addr) {
		return await this.gMasterContract.calculateStaticIncome(_addr).call();
	},

	//获取该层节点数量
	async nodeLength(_level) {
		return await this.gMasterContract.nodeLength(_level).call();
	},
	//获取团队数量
	async teamsLength(_addr) {
		return await this.gMasterContract.teamsLength(_addr).call();
	},


	//获取昨日余额，合约余额和当前静态收益率  ====>对应网页 ""
	async getBalAndRate() {//returns (uint256 _yesBal,uint256 _nowBal,uint256 _staticRate)
		let res = await this.gMasterContract.getBalAndRate().call();
		let yesterdayBalance= res._yesBal._hex;
		let nowBalance = res._nowBal._hex;
		let staticRate = res._staticRate._hex;
		return res;
	},



	// 获取默认地址USDT余额
	async getDefaultAddressBalance() {
		let addr = await this.gTronWeb.defaultAddress.base58;
		let res = await this.gUSDTContract.balanceOf(addr).call();
		return res.balance;
	},


};

export default contract;



// WEBPACK FOOTER //
// ./src/common/contractECO_V2.js